import React, { useContext } from "react";
import { observer } from "mobx-react";
import { PlayerSowStoreContext } from "@state/context/sow/PlayerSowStoreContext";

import { Button } from "@components/buttons";
import { useTranslation } from "react-i18next";

export const SowFilesSection = observer(function SowFilesSection() {
	const playerSowStore = useContext(PlayerSowStoreContext);

	const { t } = useTranslation();

	if (!playerSowStore?.files) {
		return null;
	}

	if (playerSowStore?.files.length === 0) {
		return null;
	}

	return (
		<div className="row u-mar--top--xsml">
			{playerSowStore.files.map((file, idx) => {
				let fileTypeAbrv = file.type.split("/")[1];

				if (
					fileTypeAbrv ===
					"vnd.openxmlformats-officedocument.wordprocessingml.document"
				) {
					fileTypeAbrv = "docx";
				}

				if (fileTypeAbrv === "vnd.ms-excel") {
					fileTypeAbrv = "xls";
				}

				if (
					fileTypeAbrv ===
					"vnd.openxmlformats-officedocument.spreadsheetml.sheet"
				) {
					fileTypeAbrv = "xlsx";
				}

				return (
					<div
						key={file.name + idx}
						className="card--primary__col col col-sml-12 col-lrg-6"
					>
						<div className="card--file card--file--grow card--file--row card--primary">
							<a
								href={URL.createObjectURL(file)}
								target="_blank"
								className="card--file__body u-mar--bottom--reset u-padd--right--med"
							>
								<i
									className={
										"u-icon u-icon--xlrg u-icon--file--" +
										fileTypeAbrv
									}
								/>
								<div className="card--file__info">
									<div className="card--file__name">
										{file.name}
									</div>
									<div className="card--file__size">
										{(file.size / 1024).toFixed(2) + "KB"}
									</div>
								</div>
							</a>

							<Button
								type="button"
								className="btn--square btn--square--reset btn--ghost u-color--sent--danger card--file__del"
								iconOnly
								iconClassName="u-icon--sml u-icon--bin u-color--sent--danger"
								title={t("COMMON.DELETE")}
								onClick={() => {
									playerSowStore.removeFile(idx);
								}}
							/>
						</div>
					</div>
				);
			})}
		</div>
	);
});
